export const RETROFIT_TARGET_STANDARD_LIST = [
    { key: "KFW_70_TO_85", band: "LOW" },
    { key: "KFW_40_TO_55", band: "VERY_LOW" },
];
export const RETROFIT_TARGET_STANDARD_KEY_LIST = RETROFIT_TARGET_STANDARD_LIST.map((standard) => standard.key);
export const isRetrofitTargetStandardKey = (value) => typeof value === "string" && RETROFIT_TARGET_STANDARD_KEY_LIST.includes(value);
